import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { AppState } from "store";
import { ThunkDispatch } from "redux-thunk";
import { logout } from "store/actions/authActions";
import CompanySelection from "components/layout/companySelection";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
import { loadProfileLanguageAsync } from "store/actions/commonActions";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const companies = useSelector<AppState, WintSuperkollAPIModel.Company[] | undefined>((store) => store.auth.companies);

  const onLogoutClick = () => {
    dispatch(logout());
    navigate("/Login", { replace: true });
  };

  React.useEffect(() => {
    dispatch(loadProfileLanguageAsync());
  }, []);

  return (
    <CompanySelection
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.NotFoundTitle)}
      explanation={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.NotFoundDescription)}
      selectCompanyText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.NotFoundSelectCompany)}
      companies={companies ? companies.map((c) => ({ id: c.id, name: c.name ?? "", url: `/${c.url}` })) : []}
      logOut={onLogoutClick}
    />
  );
};

export default NotFound;
